import { Mail, Building, Phone, Truck } from "lucide-react";

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="mt-auto border-t border-border/50 bg-card/50 backdrop-blur-sm">
      <div className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          {/* Brand */}
          <div className="flex items-center gap-4">
            <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center shadow-lg shadow-primary/20">
              <Truck className="h-5 w-5 text-primary-foreground" />
            </div>
            <div>
              <p className="font-bold text-foreground tracking-tight">GLASSY FINISH LTD</p>
              <p className="text-xs text-muted-foreground">Company No. 15853766</p>
            </div>
          </div>
          
          {/* Contact Links */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-6">
            <a 
              href="mailto:info@glassyfinishltd.com" 
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors group"
            >
              <div className="p-1.5 rounded-lg bg-muted/50 group-hover:bg-primary/10 transition-colors">
                <Mail className="h-4 w-4" />
              </div>
              <span className="font-medium">info@glassyfinishltd.com</span>
            </a>
            <a 
              href="tel:+442071018005" 
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors group"
            >
              <div className="p-1.5 rounded-lg bg-muted/50 group-hover:bg-primary/10 transition-colors">
                <Phone className="h-4 w-4" />
              </div>
              <span className="font-medium">0207 101 8005</span>
            </a>
          </div>
        </div>
        
        {/* Bottom bar */}
        <div className="mt-6 pt-6 border-t border-border/30 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-muted-foreground">
            © {currentYear} Glassy Finish Ltd. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            Professional Delivery Management System
          </p>
        </div>
      </div>
    </footer>
  );
}